module.exports = __webpack_public_path__ + "static/media/testomonial3.cd802bcd.jpg";